module.exports = __webpack_public_path__ + "img/ObenUeberEineRollenTransp.b7a82738.png";